import request from '@/service/lib/request'

/**
 * 孢子仪 - 获取图片列表
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function imgs(params) {
  return request({
    url: `/api/v2/ruibao/imgs`,
    method: 'get',
    params
  })
}
